/*
 * @Author: your name
 * @Date: 2021-06-10 13:46:56
 * @LastEditTime: 2021-08-10 17:28:58
 * @LastEditors: Please set LastEditors
 * @Description: 欧拉相关接口
 * @FilePath: \gwm-marketing-h5\src\api\ora\index.js
 */
import request from "../../utils/request.js";
import exrequest from "../../utils/exrequest.js";
import omsrequest from "../../utils/omsrequest.js";
import anrequest from "../../utils/anrequest";
import finalrequest from "../../utils/finalrequest";
import qarequest from "../../utils/qarequest";


// 活动详情
// /v1/community/mactalk/act/getActDetailById/{actId}
export function mactalk(data, headers) {
  return request({
    url: `/api-c/v1/community/mactalk/act/getActDetailById/${data.actId}`,
    method: "GET",
    headers,
  });
}

// 活动成员列表
export function actUserList(data, headers) {
  return request({
    url: "/api-c//v1/community/mactalk/act/user/list",
    method: "POST",
    data,
    headers,
  });
}

// 活动报名
export function actSign(data, headers) {
  return request({
    url: "/api-c/v1/community/mactalk/act/v2Sign",
    method: "POST",
    data,
    headers,
  });
}

// 车友会详情
export function clubData(basicId, headers) {
  return request({
    url: `/api-c/v1/community/mactalk/basic/view/${basicId}`,
    method: "get",
    headers,
  });
}

// 车友会成员
export function memberList(data, headers) {
  return request({
    url: "/api-c//v1/community/mactalk/member/list",
    method: "post",
    headers,
    data
  });
}

// 车友会动态
export function queryPostsDynomicAllByMactalkDTO(data, headers) {
  return request({
    url: "/api-c/v1/community/stream/queryPostsDynomicAllByMactalkDTO",
    method: "post",
    headers,
    data
  });
}

// 车友会活动
export function getBasicAct(data, headers) {
  return request({
    url: "/api-c/v1/community/mactalk/act/getBasicAct",
    method: "post",
    headers,
    data
  });
}


// // 车友会活动
// export function actListApp(data, headers) {
//   return request({
//     url: "/api-c/v1/community/mactalk/act/listApp",
//     method: "post",
//     headers,
//     data
//   });
// }

// 获取注册验证码
export function getSMSCode(data, headers) {
  return request({
    url: "/api-u/v1/user/auth/getSMSCode",
    method: "POST",
    headers,
    data
  });
}
// 提交注册信息
export function loginForCode(data, headers) {
  return request({
    url: "/api-u/v1/user/auth/loginForCode",
    method: "POST",
    headers,
    data
  });
}

// 提交预约试驾
export function createOra(data, headers) {
  return request({
    url: "/api-m/v1/mycar/subscribe/create",
    method: "POST",
    data,
    headers,
  });
}

//查询所有车型
export function listSeries(data, headers) {
  return request({
    url: "/api-m/v1/mycar/base/listSeries",
    method: "POST",
    data,
    headers,
  });
}

//根据UserId查询用户信息
export function getByUserId(data, headers) {
  return request({
    url: "/api-u/v1/user/info/getByUserId/" + data.id,
    method: "GET",
    headers,
  });
}

//经销商列表
export function dealerListAll(data, headers) {
  return request({
    url: "/api-m/v1/mycar/dealer/listAll",
    method: "POST",
    data,
    headers,
  });
}

//城市
export function regionListAll(data, headers) {
  return request({
    url: "/api-s/v1/system/region/listAll",
    method: "POST",
    data,
    headers,
  });
}

//短信验证码验证
export function smsValid(data, headers) {
  return request({
    url: "/api-msg/v1/msg/sms/validCode",
    method: "POST",
    data,
    headers,
  });
}

//邀请试驾短信验证码发送  /v1/msg/sms/sendSms
export function smsSend(data, headers) {
  return request({
    url: "/api-msg/v1/msg/sms/push",
    method: "POST",
    data,
    headers,
  });
}
//获取微信小程序支付信息
export function miniPayData(data, headers) {
  return exrequest({
    url: "/gw-newrtl-shop-api/shop/v1.0/orders/miniPayData",
    method: "POST",
    data,
    headers,
  });
}
//订单详情  
export function orderDetail(data, headers) {
  return request({
    url: "/api-m/v1/mycar/buy/order/detail/" + data.id,
    method: "GET",
    data,
    headers,
  });
}
//订单列表 
export function orderList(data, headers) {
  return request({
    url: "/api-m/v1/mycar/buy/order/list",
    method: "POST",
    data,
    headers,
  });
}
//价格明细
export function skuList(params, headers) {
  return exrequest({
    url: "/gw-newrtl-shop-api/shop/v1.0/product/vehicle-sku/new-list",
    method: "GET",
    params,
    headers,
  });
}
//支付
export function payUrl(data, headers) {
  return exrequest({
    url: "/gw-newrtl-shop-api/shop/v1.0/orders/payUrl",
    method: "POST",
    data,
    headers,
  });
}
//登录
export function login(data, headers) {
  return request({
    url: "/api-u/v1/user/auth/loginForPwd",
    method: "POST",
    data,
    headers,
  });
}
//获取
export function modelList(params, headers) {
  return exrequest({
    url: "/gw-newrtl-shop-api/shop/v1.0/product/vehicle-model/list",
    method: "GET",
    params,
    headers,
  });
}
//
export function stageStatus(data, headers) {
  return omsrequest({
    url: "/openapi/v1/order/stage/status",
    method: "POST",
    data,
    headers,
  });
}
//订单修改
export function stageStatusOra(params, headers) {
  return request({
    url: "/api-m/v1/mycar/oms/order/stageStatus/",
    method: "POST",
    params,
    headers,
  });
}
//订单跟踪
export function getOrderTrackingUrl(params, headers) {
  return request({
    url: "/api-m/v1/mycar/oms/order/getOrderTrackingUrl/",
    method: "GET",
    params,
    headers,
  });
}
//申请退款
export function orderRefund(data, headers) {
  return request({
    url: `/api-m/v1/mycar/buy/order/refund/${data.id}`,
    method: "GET",
    headers,
  });
}
//提交退款
export function refundSubmit(data, headers) {
  return anrequest({
    url: "/api-m/v1/mycar/buy/order/refund/submit",
    method: "POST",
    data,
    headers,
  });
}
//取消订单 小定
export function orderCancel(data, headers) {
  return anrequest({
    url: `/api-m/v1/mycar/buy/order/cancel/${data.id}`,
    method: "GET",
    headers,
  });
}
//取消订单 大定
export function bigCancelOrder(data, headers) {
  return anrequest({
    url: "/api-m/v1/mycar/buy/order/cancelOrder",
    method: "POST",
    data,
    headers,
  });
}
//取消订单 大定
export function serviceTermsQuery(data, headers) {
  return request({
    url: "/api-m/v1/mycar/serviceTerms/query",
    method: "POST",
    data,
    headers,
  });
}
//尾款列表
export function separationList(params, headers) {
  return finalrequest({
    url: "/gw-newrtl-shop-api/shop/v1.0/orders/separation/list",
    method: "GET",
    params,
    headers,
  });
}
//查询保险信息
export function getTypeByModelId(data, headers) {
  return anrequest({
    url: `/api-m/v1/mycar/base/getTypeByModelId/${data.id}`,
    method: "GET",
    headers,
  });
}
//查询问题详情
export function getQuestionDetail(data, headers) {
  return qarequest({
    url: "/app-api/api/v1.0/technician/portal/questionDetail/route/getQuestionDetail",
    method: "POST",
    data,
    headers,
  });
}
//用户查询
export function getUserInfo(data, headers) {
  return anrequest({
    url: `/api-u/v1/user/info/getByUserId/${data}`,
    method: "GET",
    headers,
  });
}

